import { render, staticRenderFns } from "./DeviceDetector.vue?vue&type=template&id=6204b1ea&"
import script from "./DeviceDetector.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports